import(/* webpackMode: "eager" */ "/root/repo/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/app/(public)/[sport]/players/[id]/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/game/card/detailed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/back-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/team/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameProvider"] */ "/root/repo/client/src/utils/providers/game.tsx");
